// extracted by mini-css-extract-plugin
export default {"addToCollection":"WG-z"};